<template>
  <div>
    <div class="d-flex align-items-center">
      <h5 class="mr-3">¿Qu&eacute; son las consecuencias?</h5>
      <vs-button class="p-3" icon-after icon="info" @click="$refs.info.show()">
        Explicaci&oacute;n
      </vs-button>
      </div>
    <b-modal title="Consecuencias" size="lg" centered no-close-on-backdrop hide-footer ref="info">
      <p>
        <b>
          Una consecuencia es lo que suceder&aacute; con el
        documento que sea enviado a este flujo una vez que sea aprobado, rechazado o anulado.
        </b>
      </p>
      <p>
        Estas consecuencias son:
        <br>
        <ul>
          <li>
            <b>1. Post Iniciado:</b> Es lo que sucede inmediatamente al ingresar
            o iniciar su proceso de aprobaci&oacute;n.
          </li>
          <li>
            <b>2. Post Aprobado:</b> Es lo que sucede cuando el resultado final
            del flujo es aprobado.
          </li>
          <li>
            <b>3. Post Rechazado:</b> Es lo que sucede cuando el resultado
            final del flujo es rechazado.
          </li>
          <li>
            <b>4. Post Proceso:</b> Es lo que sucede al finalizar el flujo, sin importar
            el resultado.
          </li>
          <li>
            <b>5. Post Desestimado:</b> Es lo que sucede si un flujo es anulado.
          </li>
        </ul>
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ConsequencesInfo'
};
</script>
